import axios from 'axios';
import config from '../config';
import { OnboardDeviceLogsUploadStatus } from '../interfaces';

export const getOnboardDeviceLogsUploadStatus = (
    requestId: string,
): Promise<OnboardDeviceLogsUploadStatus> => {
    const url = `${config.API_URL}/onboard-devices/logs/${requestId}/status`;

    return axios.get(url).then((response: any) => {
        return response.data;
    });
};
